// Polaris React holdouts — Skeleton* (no web component equivalent per migration plan §10).
import { SkeletonBodyText, SkeletonDisplayText } from "@shopify/polaris";

export default function DashboardSkeleton() {
  return (
    <s-page heading="Nudgesmart Dashboard" inlineSize="large">
      <s-stack direction="block" gap="base">
        <s-query-container>
          <s-grid gridTemplateColumns="@container (inline-size > 720px) 2fr 1fr, 1fr" gap="base">
            {/* Main Content (2/3) - Analytics + Active Campaigns */}
            <s-stack direction="block" gap="base">
              {/* Analytics Overview Skeleton */}
              <s-section>
                <s-stack direction="block" gap="base">
                  <s-stack direction="inline" justifyContent="space-between">
                    <SkeletonDisplayText size="small" />
                    <SkeletonDisplayText size="small" />
                  </s-stack>
                  <s-grid gridTemplateColumns="repeat(4, 1fr)" gap="base">
                    <s-box><SkeletonBodyText lines={2} /></s-box>
                    <s-box><SkeletonBodyText lines={2} /></s-box>
                    <s-box><SkeletonBodyText lines={2} /></s-box>
                    <s-box><SkeletonBodyText lines={2} /></s-box>
                  </s-grid>
                </s-stack>
              </s-section>

              {/* Active Campaigns Skeleton */}
              <s-section>
                <s-stack direction="block" gap="base">
                  <s-stack direction="inline" justifyContent="space-between">
                    <SkeletonDisplayText size="small" />
                    <SkeletonDisplayText size="small" />
                  </s-stack>
                  <SkeletonBodyText lines={1} />
                  <SkeletonBodyText lines={4} />
                </s-stack>
              </s-section>
            </s-stack>

            {/* Sidebar (1/3) - What's New + Support + Summary */}
            <s-stack direction="block" gap="base">
              <s-section>
                <s-stack direction="block" gap="small">
                  <SkeletonDisplayText size="small" />
                  <SkeletonBodyText lines={3} />
                </s-stack>
              </s-section>

              <s-section>
                <s-stack direction="block" gap="small">
                  <SkeletonDisplayText size="small" />
                  <SkeletonBodyText lines={2} />
                </s-stack>
              </s-section>

              <s-section>
                <s-stack direction="block" gap="small">
                  <SkeletonDisplayText size="small" />
                  <SkeletonBodyText lines={3} />
                </s-stack>
              </s-section>
            </s-stack>
          </s-grid>
        </s-query-container>
      </s-stack>
    </s-page>
  );
}
